export enum ThemeModesEnum {
  Dark = 'dark',
  Light = 'light',
}

export interface ThemeMode {
  mode: ThemeModesEnum;
}
